import React from "react";
import { getImgPath } from "../common/helper";
import {
  t,
  TAB3_HEADING1,
  TAB3_HEADING2,
  TAB3_HEADING3,
  TAB3_LI1,
  TAB3_LI2,
  TAB3_LI3,
  TAB3_LI4,
  TAB3_LI5,
} from "../../translations/AboutUs/BusServiceAiravatBliss";

function BusServiceAiravatBliss() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <div style={{ fontSize: "20px", fontWeight: "600", textAlign: "left" }}>
        {t(TAB3_HEADING1)}
      </div>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <div>
          <img
            src={getImgPath("/img/aboutus/bus_service/Airavat Bliss.png")}
            alt=""
          />
        </div>
      </div>
      <div style={{ fontSize: "16px", fontWeight: "400" }}>
        {t(TAB3_HEADING2)}
      </div>
      <div style={{ fontSize: "16px", fontWeight: "600", textAlign: "left" }}>
        {t(TAB3_HEADING3)}
      </div>
      <div>
        <ul style={{ margin: "0", padding: "0", marginLeft: "48px" }}>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB3_LI1)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB3_LI2)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB3_LI3)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB3_LI4)}</li>
          <li style={{ fontSize: "14px", fontWeight: "400" }}>{t(TAB3_LI5)}</li>
        </ul>
      </div>
    </div>
  );
}

export default BusServiceAiravatBliss;
